export default new Proxy({}, { get: (_, prop) => `dc-${prop}` });